import React from "react";
import { Twemoji } from "react-emoji-render";

import { Grid, Typography } from "@material-ui/core";

import useStyles from "./styles";

const PendingComponent = ({
  msg = "Este componente está en desarrollo.",
  emoji = "👷‍♀️ 👷"
}) => {
  const { penRoot, message } = useStyles();
  return (
    <Grid container item xs className={penRoot}>
      <Typography className={message}>
        <Twemoji svg text={emoji} />
        <br></br> {msg}
      </Typography>
    </Grid>
  );
};

export default PendingComponent;
